import {
  ServiceContainer,
  createServiceType,
} from '@tv2-player/service-container/src/serviceContainer';
import { MetricListener } from '@tv2-player/overseer-telemetry/src/telemetry';

export const OverseerTrackPluginCallService = createServiceType<OverseerTrackPluginCallService>();
export interface OverseerTrackPluginCallService {
  trackPluginCall(plugin: string, name: string, value?: any, metadata?: any): void;
  setMetadata(metadata: Record<string, any>): void;
}

/**
 * Handles an event from "onMessage" from a worker and track the call
 * @param msg The message event to parse
 */
export function handleOverseerMessage(msg: MessageEvent) {
  switch (msg.data.type) {
    case 'overseer.trackPluginCall':
      ServiceContainer.get(OverseerTrackPluginCallService)?.trackPluginCall(
        msg.data.plugin,
        msg.data.name,
        msg.data.value,
        msg.data.metadata
      );
  }
}

export function trackPluginCall(plugin: string, name: string, value?: any, metadata?: any) {
  const service = ServiceContainer.get(OverseerTrackPluginCallService);
  service?.trackPluginCall(plugin, name, value, metadata);
}

/**
 * A metric listener that sends all metrics to overseer-ui
 */
export class OverseerMetricListener implements MetricListener {
  onMetric(metricName: string, metricValue: number, metadata: Record<string, string>) {
    trackPluginCall('metrics', metricName, { metricValue, metadata });
  }
}
